import tlBG from "../../../assets/images/gradientBg.png";
import { COLORS } from "../../../lib/styles/styles";
import tw, { styled } from "twin.macro";
import "antd/dist/antd.css";

export const CardTimeline = styled.div`
	${tw`overflow-hidden`}
	display: flex;
	gap: 10px;
	justify-content: center;
	align-items: center;
	max-width: ${({ large }) => (large ? "1240px" : "480px")}!important;
	max-height: ${({ large }) => (large ? "540px" : "360px")} !important;
	min-width: ${({ large }) => (large ? "480px" : "320px")} !important;
	min-height: ${({ large }) => (large ? "540px" : "360px")} !important;
	width: 100%;
	height: 100%;
	border-radius: 10px;
	position: ${({ position }) => (position ? position : "relative")};
	background-color: ${COLORS.appGentleGray};
	background-blend-mode: multiply;
	background-image: ${({ background }) =>
		background ? `url(${background});` : `url(${tlBG});`};
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;

	@media (max-width: 768px) {
		max-width: ${({ large }) => (large ? "auto" : "320px")}!important;
		max-height: ${({ large }) => (large ? "540px" : "320px")} !important;
		min-width: ${({ large }) => (large ? "300px" : "300px")} !important;
		min-height: ${({ large }) => (large ? "400px" : "340px")} !important;
	}

	@media (max-width: 327px) {
		max-width: ${({ large }) => (large ? "275px" : "275px")}!important;
		max-height: ${({ large }) => (large ? "540px" : "400px")} !important;
		min-width: ${({ large }) => (large ? "285px" : "285px")} !important;
		min-height: ${({ large }) => (large ? "340px" : "340px")} !important;
	}

	.midFadedBg {
		background: rgba(50, 50, 50, 0.5);
		backdrop-filter: blur(4px);
		border-radius: 50px;
	}

	.item-container {
		.ant-image {
			width: auto;
			display: flex;
			height: 100%;
			max-height: ${({ large }) =>
				large ? "540px" : "360px"} !important;

			@media (max-width: 320px) {
				max-height: 100% !important;
			}
		}
	}
`;

export const CarouselItemNumber = styled.div`
	background-color: "#494950" !important;
	color: #ffffff !important;
	mix-blend-mode: hard-light;
`;

export const SprayContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	padding: 10px;
	background: rgba(50, 50, 50, 0.1);
	backdrop-filter: blur(4px);
	z-index: 10000000;
	border-radius: 50%;

	@media (max-width: 376px) {
		max-width: 120px !important;
		max-height: 120px !important;
	}
`;

export const SprayContent = styled.div`
	background: rgba(50, 50, 50, 0.8);
	backdrop-filter: blur(4px);
	border-radius: 50%;
	display: flex;
	padding: 10px;
	gap: 2px;
	flex-direction: row;
	align-items: center;
	justify-content: center;

	@media (max-width: 376px) {
		max-width: 100px !important;
		max-height: 100px !important;

		.sprayAmount {
			font-size: 1.25rem !important;
		}

		.sprayCurrency {
			font-size: 0.5rem !important;
			margin-top: 16px !important;
		}

		.sprayTitle {
			font-size: 1rem !important;
		}
	}
`;

export const SpraySelectContainer = styled.div`
	background: rgba(50, 50, 50, 0.8);
	backdrop-filter: blur(4px);
	border-radius: 12px;
	z-index: 100000000 !important;

	.ant-radio-wrapper {
		color: #fff;
		font-size: 0.65rem;
		margin: 0 !important;
		.ant-radio-inner {
			${tw`border border-appPink`}
			background-color: transparent;
			::after {
				background-color: transparent;
			}
		}
		.ant-radio-checked > .ant-radio-inner {
			::after {
				background-color: red;
			}
		}
	}
`;
